export function formatPercent(percent, fallback = 0) {
  const num = isNaN(percent) ? fallback : percent;
  const rounded = Math.round(num * 1000) / 10;
  const fixed = rounded.toFixed(1);
  return `${fixed}%`;
}
